import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import numeral from 'numeral';
import { Flex, Box } from 'rebass/styled-components';
import theme from 'styled-theming';

const backgroundColor = theme.variants('mode', 'mode', {
  total: {
    light: (props) => props.theme.colors.lightGreyBlue,
    dark: (props) => props.theme.colors.richBlue,
  },
  item: {
    light: (props) => props.theme.colors.white,
    dark: (props) => props.theme.colors.lpGhost,
  },
});

const textColor = theme.variants('mode', 'mode', {
  total: {
    light: (props) => props.theme.colors.white,
    dark: (props) => props.theme.colors.white,
  },
  item: {
    light: (props) => props.theme.colors.teal,
    dark: (props) => props.theme.colors.white,
  },
});

const AnalyticsWrapper = styled(Flex)`
  background-color: ${backgroundColor};
  width: ${(props) => props.itemHeight + 46}px;
  height: ${(props) => props.itemHeight}px;
  flex-shrink: 0;
  color: ${textColor};
  border-radius: ${(props) => props.theme.radius.medium};
  overflow: hidden;
`;

const Count = styled(Box)`
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const AnalyticsItem = (props) => {
  const { data, mode, itemHeight } = props;

  const label = capitalize(data.name ? data.name : mode);
  const count = typeof data === 'object' ? data.count : data;
  const format = count > 1000 ? '0.0a' : '0a';

  const smallSize = itemHeight === 60;

  return (
    <AnalyticsWrapper
      alignItems="center"
      justifyContent="center"
      mr={smallSize ? 2 : 3}
      mt={smallSize ? 2 : 3}
      mode={mode}
      title={`${label}\n${count}`}
      itemHeight={itemHeight}
      data-testid="analytics-item"
    >
      <Box p={smallSize ? 2 : 3} flex={1}>
        <Count fontSize={smallSize ? 2 : 4} data-testid="analytics-item-count">
          {numeral(count).format(format)}
        </Count>
        <Count fontSize={smallSize ? '8px' : 0} mt={2} data-testid="analytics-item-subtitle">
          {label}
        </Count>
      </Box>
    </AnalyticsWrapper>
  );
};

AnalyticsItem.defaultProps = {
  mode: 'item',
  data: undefined,
};

AnalyticsItem.propTypes = {
  itemHeight: PropTypes.number.isRequired,
  mode: PropTypes.string,
  data: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.number,
  ]),

};

export default AnalyticsItem;
